import { GraphQLError } from 'graphql';
import authServices from '../../main/DependencyInjection';

/**
 * Checks if an error is an authentication error
 * @param error The error to check
 * @returns boolean indicating if the error is an auth error
 */
export const isAuthError = (error: any): boolean => {
  // Check for GraphQL errors
  if (error instanceof GraphQLError) {
    const extensions = error.extensions;
    return (
      extensions?.code === 'AUTH_NOT_AUTHORIZED' ||
      extensions?.statusCode === '401' ||
      error.message.includes('not authorized') ||
      error.message.includes('unauthorized')
    );
  }

  // Check for Axios errors
  if (error.response) {
    return error.response.status === 401;
  }

  // Check for error objects with similar structure
  if (error.extensions) {
    return (
      error.extensions.code === 'AUTH_NOT_AUTHORIZED' ||
      error.extensions.statusCode === '401' ||
      (error.message && (error.message.includes('not authorized') || error.message.includes('unauthorized')))
    );
  }

  // Check for plain error objects with auth-related messages
  if (error.message) {
    return (
      error.message.toLowerCase().includes('not authorized') ||
      error.message.toLowerCase().includes('unauthorized') ||
      error.message.toLowerCase().includes('authentication') ||
      error.message.toLowerCase().includes('auth')
    );
  }

  return false;
};

/**
 * Handles authentication errors by saving the return URL and redirecting to login
 */
export const handleAuthError = (): void => {
  if (!window.location.href.includes('/login')) {
    authServices.authService.saveReturnToUrl();
    window.location.pathname = '/login';
  }
};
